import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLocation, Navigate } from 'react-router-dom';
import Login from './Login';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isStudent, isLoading, login } = useAuth();
  const location = useLocation();

  // Check if this is a student route (must match /student/ or exactly /student)
  const isStudentRoute = location.pathname === '/student' || location.pathname.startsWith('/student/');

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // Show login page if not authenticated
  if (!isAuthenticated) {
    // Redirect to appropriate login based on route
    if (isStudentRoute) {
      return <Navigate to="/student/login" replace />;
    }
    return <Login onLogin={login} />;
  }

  // Check if student is trying to access teacher routes or vice versa
  if (isStudent && !isStudentRoute) {
    return <Navigate to="/student/dashboard" replace />;
  }

  if (!isStudent && isStudentRoute) {
    return <Navigate to="/dashboard" replace />;
  }

  // Show protected content if authenticated and on correct route type
  return <>{children}</>;
};

export default ProtectedRoute;
